import { render, staticRenderFns } from "./Disabled-Page.vue?vue&type=template&id=0a2651a8"
import script from "./Disabled-Page.vue?vue&type=script&lang=js"
export * from "./Disabled-Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports